import React, { FC } from "react";
import { PulseLoader } from "react-spinners";

import variables from '../../assets/styles/colors.scss';
import "./styles.scss";

const FullPageLoader: FC = ({ size = 30 }: { size?: number }) => (
  <div className="loader-container">
    <PulseLoader
      color={variables.theme_blue}
      size={size}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  </div>
);

export default FullPageLoader;
